import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image"
import Edges from "../../Edges"

interface IExpertBlockProps {
  description: string
  headingImage: {
    altText: string
    gatsbyImage: ImageDataLike
  }
  heading: string
  buttonGroup: {
    link: {
      title: string
      url: string
    }
  }[]
}

export const ExpertBlock: React.FC<IExpertBlockProps> = ({
  headingImage,
  description,
  buttonGroup,
  heading,
}) => {
  const gatsbyImage = headingImage && getImage(headingImage.gatsbyImage)

  return (
    <div className="bg-lightGrey py-14 px-[15px] md:px-0">
      <Edges size="md">
        <div className="w-full overflow-hidden rounded bg-white shadow-[0px_3px_6px_rgba(0,0,0,0.16)] ">
          <div className="mx-auto max-w-[670px] px-8 text-center ">
            <div className="pt-11">
              {gatsbyImage && (
                <GatsbyImage
                  image={gatsbyImage}
                  alt={headingImage.altText || ""}
                />
              )}
              <h3 className="my-5">{heading}</h3>
            </div>

            {description && (
              <p className=" mb-12 text-body1 text-darkGrey">{description}</p>
            )}
          </div>
          {buttonGroup && (
            <div className="bg-darkBlue py-3 text-center text-yellow">
              <p className="space-x-4 text-linkButton">
                {buttonGroup?.map(
                  ({ link }, i) =>
                    link && (
                      <React.Fragment key={i}>
                        {link?.url.includes("#hs-chat-open") ? (
                          <a href={link.url}>{link.title}</a>
                        ) : (
                          <Link to={link?.url} className="my-3 underline">
                            {link?.title}
                          </Link>
                        )}

                        {i < buttonGroup?.length - 1 && (
                          <span className="text-white">|</span>
                        )}
                      </React.Fragment>
                    )
                )}
              </p>
            </div>
          )}
        </div>
      </Edges>
    </div>
  )
}

export default ExpertBlock
